import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const AccountOpening = Loadable({
    loader: () => import(/* webpackChunkName: "AccountOpening" */ './accountOpening'),
    loading: () => <div />,
});
